export const RenderDoneSymbol = Symbol('RenderDone')
export const LayoutDoneServiceSymbol = Symbol('LayoutDoneService')
export const InternalNextRenderDoneSymbol = Symbol('InternalNextRenderDoneSymbol')
